// src/index.js
import React, { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
// import './i18n';
import { GraphProvider } from './context/GraphContext';
// const GraphProvider = lazy(() => import('./context/GraphContext'));
const Graph = lazy(() => import('./components/Graph'));

// Import global styles if any
//import FrameWithButtons from './components/FrameWithButtons';
const FrameWithButtons = lazy(() => import('./components/FrameWithButtons'));
//import NavBar from './components/NavBar';
const NavBar = lazy(() => import('./components/NavBar'));


const noFrame = new URLSearchParams(window.location.search).has('noframe');

function App() {
  return (
    <GraphProvider>
      <Suspense fallback={null}>
        <FrameWithButtons noFrame={noFrame}>
          <NavBar />
          <Graph />
        </FrameWithButtons>
      </Suspense>
    </GraphProvider>
  );
}

// Get the root element from the HTML
const container = document.getElementById('app');
const root = createRoot(container);
root.render(<App />);
